<template>
    <section class="login-wrapper">
        <section class="material-half-bg">
            <div class="cover"></div>
        </section>
        <section class="container mt-4">
            <h2 class="text-center">รายการบันทึกการตรวจสอบอุณหภูมิ <b class="text-info-emphasis">ตู้แช่ยาและเวชภัณฑ์</b>
            </h2>
            <h3 class="text-center mb-4">#{{ code }}</h3>

            <div class="text-center">
                <!-- Button to trigger modal for adding a new record -->
                <button class="btn btn-warning border-dark btn-lg mb-3"
                    @click="openFormModal">เพิ่มบันทึกการตรวจสอบ</button>
            </div>

            <!-- Chart Medicine Cabinet -->
            <div class="card mb-3">
                <div class="card-body">
                    <ChartMedicineCabinet :key="chartKey" />
                </div>
            </div>

            <!-- Table for displaying records -->
            <div class="card mb-3">
                <div class="card-body">

                    <!-- <div v-if="!filteredRecords.length" class="d-flex justify-content-center align-items-center">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div> -->
                    <form class="d-md-inline-block form-inline ms-auto me-0 me-md-3 mb-3">
                        <div class="input-group">
                            <select v-model="selectedMonth" class="form-select" required>
                                <option value="" disabled>- เลือกเดือน -</option>
                                <option v-for="month in months" :key="month.value" :value="month.value">{{ month.name }}
                                </option>
                            </select>

                            <select v-model="selectedYear" class="form-select ms-2" required>
                                <option value="" disabled>- เลือกปี -</option>
                                <option v-for="year in years" :key="year" :value="year">{{ year + 543 }}</option>
                            </select>

                            <button @click.prevent="clearFilters" class="btn btn-secondary" type="button">
                                <i class="bi bi-arrow-clockwise"></i> รีเซ็ต
                            </button>
                        </div>
                    </form>
                    <div v-if="!filteredRecords.length" class="text-center text-danger my-2">
                        <div class="spinner-border align-middle"></div>
                        <strong> Loading...</strong>
                    </div>
                    <div v-else class="table-responsive">

                        <table class="table table-bordered table-striped">
                            <thead class="table-dark text-center">
                                <tr>
                                    <th>วันเวลาที่บันทึก</th>
                                    <th>ช่วงเวลา</th>
                                    <th>ชื่อผู้บันทึก</th>
                                    <th>ชื่อหน่วยงาน</th>
                                    <th>รหัส-ชื่อ</th>
                                    <th>ประเภทช่องแช่</th>
                                    <th>อุณหภูมิ Temperature (°C)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(record) in filteredRecords" :key="record.id">
                                    <td>{{ formatDateTimeUTC(record.record_date) }} | {{ record.record_time }}</td>
                                    <td>{{ record.shift_type?.name }}</td>
                                    <td>{{ record.recorder }}</td>
                                    <td>{{ record.group?.name }}</td>
                                    <td>{{ record.medicine_cabinet?.code }} - {{ record.medicine_cabinet?.name }}</td>
                                    <td>{{ record.compartment_type?.name }}</td>
                                    <td>{{ record.temperature }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <hr>
                        <h4 class="text-center">ตารางสรุปรายวันแบบปฏิทิน</h4>
                        <div class="table-responsive">
                            <table class="table table-bordered text-center">
                                <thead class="table-dark">
                                    <tr>
                                        <th>ช่วงเวลา</th>
                                        <th v-for="day in daysInMonth" :key="day">{{ day }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="shift in shiftLabels" :key="shift">
                                        <th>{{ shift }}</th>
                                        <td v-for="day in daysInMonth" :key="day">
                                            <div v-if="recordsByDayShift[shift] && recordsByDayShift[shift][day]">
                                                ✅
                                                <!-- <div>{{ recordsByDayShift[shift][day].recorder }}</div> -->
                                            </div>
                                            <div v-else>-</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>


                </div>
            </div>


            <!-- Modal for inserting form data -->
            <div class="modal fade" id="Modal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="roleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">บันทึกการตรวจสอบอุณหภูมิ ตู้แช่ยาและเวชภัณฑ์</h5>
                            <button type="button" class="btn-close" @click="closeFormModal"></button>
                        </div>
                        <div class="modal-body">
                            <form @submit.prevent="handleSubmit">
                                <!-- <div class="row" hidden> -->
                                <div class="row" >
                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label">วันที่บันทึก (Record Date)</label>
                                            <!-- <DatePicker v-model="form.record_date" :disabled="true"/> -->
                                            <DatePicker v-model="form.record_date" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label class="form-label">เวลา (Record Time)</label>
                                            <TimePicker v-model="form.record_time" required />
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-3">
                                    <label class="form-label">หน่วยงาน (Department)</label>
                                    <select disabled v-model="form.group_id" class="form-select" required>
                                        <option v-for="dept in groups" :key="dept.id" :value="dept.id">
                                            {{ dept.name }}
                                        </option>
                                    </select>
                                </div>

                                <div class="mb-3">
                                    <label class="form-label">ประเภทช่องแช่ (Compartment Type)</label>
                                    <select v-model="form.compartment_type_id" class="form-select" required>
                                        <option disabled value="">- เลือกประเภทช่องแช่ -</option>
                                        <option v-for="comp in compartmentTypes" :key="comp.id" :value="comp.id">
                                            {{ comp.name }}
                                        </option>
                                    </select>
                                </div>

                                <div class="mb-3">
                                    <label class="form-label">อุณหภูมิ (Temperature °C)</label>
                                    <input type="number" step="0.1" v-model="form.temperature" class="form-control"
                                        placeholder="อุณหภูมิ" required />
                                </div>

                                <div class="mb-3">
                                    <label class="form-label">กะงาน (Shift Type)</label>
                                    <select v-model="form.shift_type_id" class="form-select" required>
                                        <option disabled value="">- เลือกกะงาน -</option>
                                        <option v-for="shift in shiftTypes" :key="shift.id" :value="shift.id">
                                            {{ shift.name }}
                                        </option>
                                    </select>
                                </div>

                                <div class="mb-3">
                                    <label class="form-label">ชื่อผู้บันทึก (Recorder)</label>
                                    <v-select v-model="form.recorder" :options="doctors" label="name"
                                        :reduce="item => item.name" :clearable="false"
                                        placeholder="ค้นหา..ชื่อผู้บันทึก">
                                        <template #search="{ attributes, events }">
                                            <input class="vs__search" :required="!form.recorder" v-bind="attributes"
                                                v-on="events" />
                                        </template>
                                    </v-select>
                                </div>

                                <hr />
                                <button type="submit" class="btn btn-lg btn-primary w-100">บันทึกข้อมูล (Save)</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    </section>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import axios from 'axios';
import axiosInstance from '@/utils/axiosInstance';
import { Modal } from 'bootstrap';
import Swal from 'sweetalert2';
import moment from 'moment';
import ChartMedicineCabinet from '@/components/ChartMedicineCabinet.vue';
import { showErrorAlert, showSuccessAlert } from '@/utils/sweetalert2-utils';
import DatePicker from '@/components/DatePicker.vue';
import TimePicker from '@/components/TimePicker.vue';

const modal = ref(null);
const records = ref([]);

// const now = moment().format('YYYY-MM-DD HH:mm:ss');
// const [dateStr] = now.split(' ');
const now = moment();

const form = ref({
    user_id: '',
    group_id: '',
    compartment_type_id: '',
    temperature: '',
    shift_type_id: '',
    medicine_cabinet_id: '',
    recorder: '',
    record_date: now.format('YYYY-MM-DD'),
    record_time: now.format('HH:mm:ss')
});

const groups = ref([]);
const compartmentTypes = ref([]);
const shiftTypes = ref([]);
const doctors = ref([]);

const route = useRoute();
const code = ref(route.params.code);
const cabinet = ref(null);
const chartKey = ref(0);

const today = new Date();
const selectedMonth = ref(today.getMonth() + 1);
const selectedYear = ref(today.getFullYear());

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 3 }, (_, i) => currentYear - i); // 5 ปีย้อนหลัง
const shiftLabels = computed(() => shiftTypes.value.map(type => type.name));

const months = [
    { value: 1, name: 'มกราคม' },
    { value: 2, name: 'กุมภาพันธ์' },
    { value: 3, name: 'มีนาคม' },
    { value: 4, name: 'เมษายน' },
    { value: 5, name: 'พฤษภาคม' },
    { value: 6, name: 'มิถุนายน' },
    { value: 7, name: 'กรกฎาคม' },
    { value: 8, name: 'สิงหาคม' },
    { value: 9, name: 'กันยายน' },
    { value: 10, name: 'ตุลาคม' },
    { value: 11, name: 'พฤศจิกายน' },
    { value: 12, name: 'ธันวาคม' }
];

const daysInMonth = computed(() => {
    return Array.from(
        { length: new Date(selectedYear.value, selectedMonth.value, 0).getDate() },
        (_, i) => i + 1
    );
});

function clearFilters() {
    selectedMonth.value = today.getMonth() + 1;
    selectedYear.value = today.getFullYear();
}

const recordsByDayShift = computed(() => {
    const map = {};

    for (let record of filteredRecords.value) {
        const date = new Date(record.record_date);
        const day = date.getDate();
        const shift = record.shift_type?.name;

        if (!map[shift]) {
            map[shift] = {};
        }

        map[shift][day] = record;
    }

    return map;
});

function formatDateTimeUTC(dateStr) {
    const m = moment.utc(dateStr).locale('th');
    const buddhistYear = m.year() + 543;
    const month = m.format('MMM');
    const day = m.format('D');
    return `${day} ${month} ${String(buddhistYear).slice(2)}`; // ได้รูปแบบ '4 มิ.ย. 68'
}

// const filteredRecords = computed(() => {
//     return records.value.filter(record => {
//         const recordDate = new Date(record.record_date);
//         return (
//             record.medicine_cabinet.code === code.value &&
//             recordDate.getMonth() + 1 === selectedMonth.value
//         );
//     });
// });

const filteredRecords = computed(() => {
    return records.value.filter(record => {
        const recordDate = new Date(record.record_date);
        return (
            record.medicine_cabinet.code === code.value &&
            recordDate.getUTCMonth() + 1 === selectedMonth.value &&
            recordDate.getUTCFullYear() === selectedYear.value
        );
    });
});


const fetchDataCode = async () => {
    try {
        const response = await axiosInstance.get(`/check_medicine_cabinet/${code.value}`);
        cabinet.value = response.data;
        form.value.group_id = response.data.group_id;
        form.value.compartment_type_id = '';
        form.value.temperature = '';
        form.value.shift_type_id = '';
        form.value.recorder = '';
        form.value.medicine_cabinet_id = response.data.id;
        fetchData(response.data.id)
    } catch (error) {
        showErrorAlert('ไม่สามารถโหลดข้อมูลได้');
    }
};

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: toast => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
    }
});

const fetchData = async (id) => {
    try {
        const response = await axiosInstance.get(`/temperature_record/medicine_cabinet/${id}`, {
            params: {
                medicine_cabinet_id: id,
                month: selectedMonth.value,
                year: selectedYear.value
            }
        });
        records.value = response.data;

        const currentDate = new Date().toISOString().split('T')[0];
        const todayRecord = response.data.find(record => {
            const createdAtDate = new Date(record.record_date).toISOString().split('T')[0];
            return createdAtDate === currentDate && record.medicine_cabinet.code === code.value;
        });

        Toast.fire({
            icon: todayRecord ? 'success' : 'error',
            title: todayRecord ? 'บันทึกแล้ว ในวันนี้!' : 'ยังไม่บันทึกแล้ว ในวันนี้!'
        });
    } catch (error) {
        showErrorAlert('ไม่สามารถโหลดข้อมูลได้');
    }
};

watch([selectedMonth, selectedYear], () => {
    if (form.value.medicine_cabinet_id) {
        fetchData(form.value.medicine_cabinet_id);
    }
});

// const getShiftName = (dateStr, timeStr) => {
//     const time = new Date(`${dateStr}T${timeStr}`);
//     const hours = time.getHours();
//     const minutes = time.getMinutes();

//     if ((hours >= 8 && hours < 14) || (hours === 13 && minutes <= 59)) {
//         return 'เวรเช้า (08:00)';
//     } else if ((hours >= 14 && hours < 21) || (hours === 20 && minutes <= 59)) {
//         return 'เวรเช้า (14:00)';
//     } else if ((hours >= 21 && hours <= 23) || (hours === 0 && minutes <= 59)) {
//         return 'เวรบ่าย (21:00)';
//     } else if ((hours >= 1 && hours < 8) || (hours === 7 && minutes <= 59)) {
//         return 'เวรดึก (01:00)';
//     } else {
//         return 'ไม่ทราบช่วงเวร';
//     }
// };

// const fetchData = async () => {
//     try {
//         const response = await axiosInstance.get('/temperature_record');
//         records.value = response.data;

//         const currentDate = new Date().toISOString().split('T')[0];
//         const todayRecord = response.data.find(record => {
//             const createdAtDate = new Date(record.record_date).toISOString().split('T')[0];
//             return createdAtDate === currentDate && record.medicine_cabinet.code === code.value;
//         });

//         if (todayRecord) {
//             const shiftName = getShiftName(todayRecord.record_date.split('T')[0], todayRecord.record_time);
//             Toast.fire({
//                 icon: 'success',
//                 title: `บันทึกแล้ว ใน${shiftName}!`
//             });
//         } else {
//             Toast.fire({
//                 icon: 'error',
//                 title: 'ยังไม่บันทึกแล้ว ในวันนี้!'
//             });
//         }

//     } catch (error) {
//         showErrorAlert('ไม่สามารถโหลดข้อมูลได้');
//     }
// };

const fetchDropdownData = async () => {
    try {
        const [deptRes, compRes, shiftRes] = await Promise.all([
            axiosInstance.get('/group'),
            axiosInstance.get('/compartment_type'),
            axiosInstance.get('/shift_type')
        ]);
        groups.value = deptRes.data;
        compartmentTypes.value = compRes.data;
        shiftTypes.value = shiftRes.data;
    } catch (error) {
        showErrorAlert('Failed to load dropdown data');
    }
};

const getDoctors = async () => {
    try {
        const res = await axios.get('https://api-hos.wanorn.com/backend/api/doctor');
        doctors.value = res.data.filter(doctor => doctor.active !== 'N');
    } catch (error) {
        showErrorAlert('ไม่สามารถโหลดข้อมูลได้');
    }
};

const handleSubmit = async () => {
    try {
        form.value.record_time = moment(form.value.record_time, 'HH:mm').format('HH:mm:ss');

        await axiosInstance.post('/temperature_record', form.value);
        showSuccessAlert('บันทึกเรียบร้อยแล้ว!');
        // fetchData();
        fetchDataCode();
        hideModal();
        chartKey.value += 1;
    } catch (error) {
        console.error(error);
        showErrorAlert('Error saving record');
    }
};

const showModal = () => modal.value.show();
const hideModal = () => modal.value.hide();

const openFormModal = () => {
    const now = moment(); // ✅ use moment() instead of new Date()
    form.value.record_date = now.format('YYYY-MM-DD');
    form.value.record_time = now.format('HH:mm:ss'); // includes seconds as required

    showModal();
};

const closeFormModal = () => {
    hideModal();
    form.value = {
        user_id: '',
        group_id: form.value.group_id,
        medicine_cabinet_id: form.value.medicine_cabinet_id,
        compartment_type_id: '',
        temperature: '',
        shift_type_id: '',
        recorder: '',
        record_date: moment().format('YYYY-MM-DD'),
        record_time: moment().format('HH:mm:ss')
    };
};

onMounted(() => {
    // fetchData();
    fetchDropdownData();
    getDoctors();
    fetchDataCode();
    modal.value = new Modal(document.getElementById('Modal'));
});
</script>


<style scoped>
.login-wrapper {
    display: flex;
    height: 100vh;
}

.material-half-bg {
    flex: 1;
}

.login-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* .card {
    width: 100%;
    max-width: 500px;
    padding: 20px;
  } */
.cover {
    background: url('https://www.infoquest.co.th/wp-content/uploads/2020/04/20200407_Pixabay_syringe-1884784_1920-1-1024x614.jpg') no-repeat center center;
    background-size: cover;
    height: 100%;
    opacity: 0.3;
    /* Adjust opacity value as needed */
}
</style>
